import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { GetNewsItemRecipientsResponse, NewsItemModel } from '../../../../api-service/clients';
import { NewsRecipientsDialogComponent } from './news-recipients-dialog-component';
import { forumRejectionReason } from '../forum-rejection-reason';

const client = moduleClientFactory.createForumCaseworkerClient();

export interface INewsRecipientsDialogProps {
  newsItem: NewsItemModel;
  canUpdate: boolean;
  onClose: () => void;
}

export function NewsRecipientsDialog(props: INewsRecipientsDialogProps) {
  const { newsItem, canUpdate, onClose } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [recipients, setRecipients] = useState<GetNewsItemRecipientsResponse>();
  const [hasFailed, setHasFailed] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    client
      .getNewsItemRecipients({ newsItemId: newsItem.id })
      .then(setRecipients)
      .catch(() => setHasFailed(true));
  }, [newsItem.id]);

  async function updateRecipients(citizenIds: string[]) {
    setIsSaving(true);
    try {
      await client.updateNewsItemRecipients({ newsItemId: newsItem.id, citizenIds });
      enqueueSnackbar('Nyhedsmodtagerne er opdateret.', { variant: 'success' });
      onClose();
    } catch (error) {
      enqueueSnackbar(forumRejectionReason(error) ?? 'Kan ikke opdatere nyhedsmodtagerne.', { variant: 'error' });
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <NewsRecipientsDialogComponent
      title={newsItem.title}
      showToAll={recipients?.showToAll ?? false}
      recipients={recipients?.recipients}
      hasFailed={hasFailed}
      isSaving={isSaving}
      onUpdateRecipients={canUpdate ? updateRecipients : undefined}
      onClose={onClose}
    />
  );
}
